import axios from '@/axios'

const RESOURCE_NAME = '/co-pace';

export default {
    getAutomotiveGroups() {
        return axios.get(`${RESOURCE_NAME}/get-automotive-groups`)
    },
}
